<template>
	<div class="mt-4 sm:w-full text-secondary" style="overflow-x: scroll">
		<table class="w-full mb-3">
			<tr>
				<th v-for="(title, titleKey) in titles" :key="titleKey">
					{{ $t(title) }}
				</th>
			</tr>
			<tr v-for="(item, itemKey) in items" :key="itemKey">
				<td class="column-width" v-for="(element, elementKey) in item" :key="elementKey">
					<toggle-button v-if="elementKey == 'active'" v-model="item.active" @change="changeState(item)" :color="colorPrimary" :sync="true" />
					<div v-else-if="elementKey == 'edit'">
						<router-link v-if="isAdmin" :to="'/admin/' + section + '/' + item.id">
							<img src="@/assets/img/editar.svg" alt="Editar" />
						</router-link>
						<router-link v-else :to="'/' + section + '/' + item.id">
							<img src="@/assets/img/editar.svg" alt="Editar" />
						</router-link>
					</div>
					<div v-else-if="elementKey == 'office'">
						<router-link :to="'/admin/listado/oficinas/' + item.id">
							<i class="fas fa-building mx-2 text-lg"></i>
						</router-link>
					</div>
					<div v-else-if="elementKey == 'download'" class="flex">
						<button @click="onDonwloadFile(item)">
							<img src="@/assets/img/files-download-file.svg" alt="Descargar" />
						</button>
					</div>
					<span v-else>{{ element }}</span>
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
import updateActiveState from '@/apollo/mutations/admin/updateSingleItemActive'

export default {
	data() {
		return {
			colorPrimary: process.env.THEME_COLOR_PRIMARY,
		}
	},
	props: {
		itemsTitles: Array,
		items: Array,
		itemsTable: String,
		active: Array,
		section: String,
		edit: {
			type: Boolean,
			default: true,
		},
		isAdmin: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		titles() {
			let header = [...this.itemsTitles]
			if (this.edit) header.push('Edit')
			header.push('Active')
			return header
		},
	},
	components: {
		ToggleButton,
	},
	methods: {
		changeState(item) {
			this.$apollo.mutate(
				updateActiveState(this.itemsTable, {
					active: item.active,
					id: item.id,
				})
			)
		},
		onDonwloadFile(item) {
			this.isLoading = true
			this.$axios
				.get('documents/download/' + item.id)
				.then(response => {
					this.isLoading = false
					window.open(response.data.data.FileUrl)
				})
				.catch(() => {
					this.isLoading = false
				})
		},
	},
}
</script>

<style scoped>
.column-width {
	max-width: 300px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
tr th {
	font-weight: 500;
	text-align: left;
	border-bottom: 1px solid black;
}
table tr:nth-child(even) {
	background: #f5f5f5;
}
td,
th {
	padding: 10px;
}
input[type='checkbox'].check-custom {
	position: absolute;
	width: 18px;
	height: 18px;
	overflow: hidden;
	margin-top: 5px;
	opacity: 0;
	cursor: pointer;
}
input[type='checkbox'].check-custom ~ .check-toggle {
	width: 1rem;
	height: 1rem;
	display: inline-block;
	vertical-align: middle;
	border: 1px solid #969696;
	border-radius: 5px;
	cursor: pointer;
	background: #fff;
}
input[type='checkbox'].check-custom:hover ~ .check-toggle {
	border-color: #68ace1;
}
input[type='checkbox'].check-custom:checked ~ .check-toggle {
	border-color: #68ace1;
	background: #68ace1 url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48cG9seWxpbmUgcG9pbnRzPSIyMCA2IDkgMTcgNCAxMiI+PC9wb2x5bGluZT48L3N2Zz4=) center no-repeat;
	background-size: 75%;
}
</style>
